'use strict';

const cache = {}

export function proxyRequest(method, uri, data) {
    const params = {
        method: method,
        mode: 'cors',
        credentials: 'omit',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer',
    }

    uri = '/api' + uri;

    if (data && (method === 'POST' || method === 'PUT')) {
        params.body = JSON.stringify(data);
    } else if (data) {
        uri += '?' + new URLSearchParams(data);
    }

    if (method === 'GET' && uri in cache) {
        return cache[uri];
    }

    cache[uri] = fetch(uri, params).then(response => { // eslint-disable-line compat/compat
        if (response.ok) {
            if (response.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return response.json();
            }

            return response.text();
        }

        if (response.headers.get('Content-Type').indexOf('application/json') !== -1) {
            return response.json().then(content => {
                return Promise.reject(content); // eslint-disable-line compat/compat
            });
        }

        return response.text().then(content => {
            return Promise.reject(content); // eslint-disable-line compat/compat
        });
    }).finally(() => {
        // Delete cache after a small delay
        if (method === 'GET' && uri in cache) {
            setTimeout(() => (delete cache[uri]), 250);
        }
    });

    return cache[uri];
}

export function proxyGet(uri, data) {
    return proxyRequest('GET', uri, data);
}

export function proxyPost(uri, data) {
    return proxyRequest('POST', uri, data);
}

export function proxyPut(uri, data) {
    return proxyRequest('PUT', uri, data);
}

export function proxyDelete(uri, data) {
    return proxyRequest('DELETE', uri, data);
}

export default {
    request: proxyRequest,
    get: proxyGet,
    post: proxyPost,
    put: proxyPut,
    delete: proxyDelete,
}
